module.exports = __webpack_public_path__ + "img/Malawi.a740819b.svg";